import { Theme, makeStyles } from '@material-ui/core/styles';
import React from 'react';
import clsx from 'clsx';

const dividerStyles = makeStyles((theme: Theme) => ({
    divider: {
        marginLeft: '1rem',
        marginRight: '1rem',
        width: '1px',
        backgroundColor: theme.palette.divider,
        lineHeight: '2rem'
    }
}));

export const NavBarDivider = (props: NavBarDividerProps): JSX.Element => {
    const { classes: customClasses } = props;

    const classes = dividerStyles();

    return <div className={clsx(classes.divider, customClasses && customClasses.divider)}>&nbsp;</div>;
};

export interface NavBarDividerProps {
    classes?: Partial<Record<'divider', string>>;
}
